import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon } from '#const';
import { getIconUrl } from '#utils';

const CtaSection = dynamic(() => import('./CtaSection'));

Builder.registerComponent(CtaSection, {
	name: 'CtaSection',
	inputs: [
		{
			name: 'copy',
			friendlyName: 'Text',
			type: 'richText',
			required: true,
			defaultValue: '<h2>An Example Headline</h2>',
		},
		{
			name: 'variant',
			friendlyName: 'Variant',
			type: 'string',
			required: true,
			enum: ['Inline', 'Stacked'],
			defaultValue: 'Stacked',
		},
		{
			name: 'color',
			friendlyName: 'Background Color',
			type: 'color',
			defaultValue: '#ECFEFF',
			helperText: 'Be sure to select a color light enough for the text to have contrast',
		},
	],
	canHaveChildren: true,
	defaultChildren: [
		{
			'@type': '@builder.io/sdk:Element',
			component: {
				name: 'Button',
				options: {
					copy: "What's My Claim Worth?",
					arrow: false,
					color: 'rgba(17, 186, 0, 1)',
				},
			},
		},
	],
	childRequirements: {
		message: 'Child must be a Button.',
		query: { 'component.name': { $eq: 'Button' } },
	},
	image: getIconUrl(Icon.CTASection),
});
